//@flow
import React from 'react';

import {makeStyles, TableCell} from '@material-ui/core';
import ActiveCheckBox from '../../ActiveCheckbox';
import {useVariantMixAndMatch} from '../../../context/productVariantRequest';

const useStyles = makeStyles(theme => ({
  combinationCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '140px',
  },
}));

export default function VariantCombinationCell() {
  const classes = useStyles();

  const [enabledMixAndMatch] = useVariantMixAndMatch();

  return (
    <TableCell component="th" scope="row" align="right">
      <div className={classes.combinationCell}>
        <ActiveCheckBox pointerNone checked={enabledMixAndMatch} />
      </div>
    </TableCell>
  );
}
